var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo, useRef } from 'react';
import { useValidateInput } from './hooks/use-validate-input';
import { mergeMetaPropsToField } from './utils/merge-meta-props-to-field';
export var ValidatedField = function (_a) {
    var component = _a.component, componentProps = _a.componentProps, fieldMeta = _a.field, formRef = _a.formRef, name = _a.name, type = _a.type, validators = _a.validators, hideErrorInXSec = _a.hideErrorInXSec;
    var inputRef = useRef();
    var _b = useValidateInput(inputRef, validators, formRef, fieldMeta, type, name, hideErrorInXSec), errors = _b.errors, setErrors = _b.setErrors;
    return useMemo(function () {
        return React.createElement(component, __assign(__assign({}, mergeMetaPropsToField(componentProps, fieldMeta)), { error: errors === null || errors === void 0 ? void 0 : errors[0], errors: errors, inputRef: inputRef, isInvalid: Boolean(errors.length), name: name, setErrors: setErrors }));
    }, [componentProps, fieldMeta, errors, inputRef, name, setErrors]);
};
